var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var UtilsService = /** @class */ (function () {
    function UtilsService() {
    }
    UtilsService.prototype.getCookieValue = function (key) {
        return abp.utils.getCookieValue(key);
    };
    UtilsService.prototype.setCookieValue = function (key, value, expireDate, path) {
        abp.utils.setCookieValue(key, value, expireDate, path);
    };
    UtilsService.prototype.deleteCookie = function (key, path) {
        abp.utils.deleteCookie(key, path);
    };
    UtilsService = __decorate([
        Injectable()
    ], UtilsService);
    return UtilsService;
}());
export { UtilsService };
